import React from "react";

export default function Analytics() {
  const rows = [
    { k: "Median SQI", v: "0.78" },
    { k: "Readiness (p50)", v: "0.71" },
    { k: "Readiness (p95)", v: "0.92" },
    { k: "Low-trust segments", v: "12%" },
  ];

  return (
    <div className="grid grid-cols-1 xl:grid-cols-2 gap-4">
      <div className="rounded-2xl border border-white/10 bg-white/5 p-4">
        <div className="text-base font-semibold mb-2">Key Metrics</div>
        <ul className="text-sm">
          {rows.map((r) => (
            <li key={r.k} className="flex items-center justify-between py-1 border-b border-white/10 last:border-0">
              <span className="opacity-70">{r.k}</span>
              <span className="font-mono">{r.v}</span>
            </li>
          ))}
        </ul>
        <div className="text-xs opacity-60 mt-3">
          Replace with Firestore reads from <span className="font-mono">/analytics</span>.
        </div>
      </div>

      <div className="rounded-2xl border border-white/10 bg-white/5 p-4">
        <div className="text-base font-semibold mb-2">Distribution (mock)</div>
        <div className="h-48 grid grid-cols-10 items-end gap-1">
          {Array.from({ length: 10 }, (_, i) => {
            const h = 20 + Math.round(Math.abs(Math.sin(i)) * 60);
            return <div key={i} className="bg-white/30 rounded-t" style={{ height: `${h}%` }} />;
          })}
        </div>
      </div>
    </div>
  );
}
